export const SKIPPED_PROPERTY_ALTERNATIVES: Record<string, string> = {
  height: "Use parent container padding or component's own size property",
  display: "Use VerticalStack (flex-column) or HorizontalStack (flex-row) for layout control",
  textAlign:
    "Use VerticalStack with textAlign style for horizontal text alignment, or HorizontalStack for side-by-side layout",
  alignItems:
    "Use HorizontalStack with alignItems style (center, flex-start, flex-end) for vertical alignment of children",
  width: "Use Column span (columns parameter on Row) to control width",
  gap: "Use VerticalStack/HorizontalStack size property to set gap between children",
  justifyContent: "Use HorizontalStack for horizontal layouts or Row+Col for grid-based alignment"
};

const CHART_COMPONENTS = new Set([
  "AreaChart",
  "BarChart",
  "LineChart",
  "PieChart",
  "DonutChart",
  "RadarChart",
  "GaugeChart",
  "MixedChart",
  "RadialChart"
]);

const CHART_SKIPPED_ALTERNATIVES: Record<string, string> = {
  borderRadius: "Wrap chart in a Panel component to achieve card-like styling with borderRadius and shadow.",
  shadowX: "Wrap chart in a Panel component to achieve card-like styling with borderRadius and shadow.",
  shadowY: "Wrap chart in a Panel component to achieve card-like styling with borderRadius and shadow.",
  shadowBlur: "Wrap chart in a Panel component to achieve card-like styling with borderRadius and shadow.",
  shadowSpread: "Wrap chart in a Panel component to achieve card-like styling with borderRadius and shadow.",
  shadowColor: "Wrap chart in a Panel component to achieve card-like styling with borderRadius and shadow."
};

export function buildSkippedWarning(property: string, componentName: string): string {
  if (property.includes("(invalid")) {
    return `${componentName}: ${property} — was skipped`;
  }
  const base = `"${property}" is not supported by ${componentName} and was skipped`;
  if (CHART_COMPONENTS.has(componentName)) {
    const chartAlt = CHART_SKIPPED_ALTERNATIVES[property];
    if (chartAlt) return `${base}. Alternative: ${chartAlt}`;
  }
  const alt = SKIPPED_PROPERTY_ALTERNATIVES[property];
  return alt ? `${base}. Alternative: ${alt}` : base;
}
